import { IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonLabel, IonLoading, IonRow, IonText, IonTitle, IonToast, IonToolbar, useIonAlert } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import "./ProjetosCupom.css";


type Props = {
  projeto: any;
  closeAction: Function;
  closeActionSimple: Function;
};

const ProjetosCupom: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const location = useLocation<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [dadosProjeto, setDadosProjeto] = useState<any>([]);

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const [mostartAlerta] = useIonAlert();
  const [editar, setEditar] = useState(false);

  const buscarInputRef = useRef<any>(null);
  const [alertConfirmar, setAlertConfirmar] = useState(false);

  const [showActionSheet, setShowActionSheet] = useState(false);

  const [showPopover, setShowPopover] = useState(false);
  const [popoverEvent, setPopoverEvent] = useState(null);

  const openPopover = (e: any) => {
    e.persist();
    setPopoverEvent(e);
    setShowPopover(true);
  };

  const closePopover = () => {
    setShowPopover(false);
    setPopoverEvent(null);
  };

  useEffect(() => {
    if (props.projeto) {
      setDadosProjeto(props.projeto);
    }
  }, [props.projeto]);

  // function getButtons() {
  //   let resultado: any = [
  //     {
  //       text: 'Cancelar',
  //       icon: close,
  //       role: 'cancel',
  //       handler: () => {
  //         console.log('Cancel clicked');
  //       }
  //     },

  //   ];



  //   resultado.push(
  //     {
  //       text: 'Cupom TXT',
  //       icon: print,
  //       handler: async () => {
  //         setShowActionSheet(false);
  //         await gerarCupom(dadosProjeto.pk);
  //       }
  //     }
  //   );

  //   resultado.push(
  //     {
  //       text: 'Cupom PDF',
  //       icon: print,
  //       handler: async () => {
  //         setShowActionSheet(false);
  //         await gerarCupomPdf(dadosProjeto.pk);
  //       }
  //     }
  //   );

  //   resultado.push(
  //     {
  //       text: 'PDF',
  //       icon: document,
  //       handler: async () => {
  //         setShowActionSheet(false);
  //         await gerarAcompanhamento(dadosProjeto.pk);
  //       }
  //     }
  //   );

  //   if (dadosProjeto.clienteInterno == true) {

  //     if (acessos?.projetos == 'edicao') {
  //       resultado.push(
  //         {

  //           text: 'Encerrar ' + window.localStorage.getItem("servicoTipo") || "Projeto",
  //           icon: checkmarkCircle,
  //           handler: () => {
  //             setShowActionSheet(false);
  //             setAlertConfirmar(true);


  //           }
  //         }
  //       )
  //     }
  //   }
  //   else {

  //     resultado.push(
  //       {
  //         text: 'Voltar',
  //         icon: arrowBack,
  //         handler: async () => {
  //           setShowActionSheet(false);
  //           props.closeActionSimple();
  //         }
  //       }
  //     );
  //   }
  //   return resultado;
  // }

  function formataTelefone(numero: any) {
    if (numero?.length == 13) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else if (numero?.length == 12) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else { return "" };
  }

  return (

    <>
      <IonHeader className="ion-no-border">
        <IonToolbar>

          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={() => props.closeActionSimple()} />
          </IonButtons>
          <IonTitle>CUPOM</IonTitle>

        </IonToolbar>


      </IonHeader>

      <IonContent fullscreen={false}>

        <div style={{ padding: '0 10px 0 10px' }}>
          <div style={{ paddingBottom: '10px', minWidth: '350px', maxWidth: '500px', margin: '50px auto 50px auto', boxShadow: '0px 0px 5px 5px rgba(0, 0, 0, 0.5)' }}>
            {dadosProjeto && (
              <IonGrid>
                <IonRow>
                  <IonCol>
                    <IonText style={{ marginBottom: '10px' }}>
                      <h2><b>{dadosProjeto.empresaNome}</b></h2>
                      <p>Endereço: {dadosProjeto.empresaEndereco}</p>
                      {/* <p>CNPJ: {dadosEmpresa.empresaCnpj}</p> */}
                      <p>Tel: {formataTelefone(dadosProjeto.empresaTelefone)}</p>
                      <p>Data: {dadosProjeto.dataCupom ? new Date(dadosProjeto.dataCupom).toLocaleDateString('pt-BR') : new Date().toLocaleDateString('pt-BR')} Hora: {dadosProjeto.dataCupom ? new Date(dadosProjeto.dataCupom).toLocaleTimeString('pt-BR') : new Date().toLocaleTimeString('pt-BR')}</p>
                    </IonText>
                  </IonCol>
                </IonRow>
              </IonGrid>
            )}
            {dadosProjeto && (
              <IonGrid>
                <hr style={{ borderTop: '1px solid', borderStyle: 'dashed', borderColor: 'grey', margin: '5px' }}></hr>
                <IonRow>
                  <IonCol>
                    <h2 style={{ padding: 0, margin: 0 }}>{dadosProjeto.servicoTipo || "Projeto"}: {dadosProjeto.nomeProjeto}</h2>
                  </IonCol>
                  <IonCol>
                    <IonText style={{ width: '100%', textAlign: 'right' }}>
                      <h2 style={{ padding: 0, margin: 0 }}>{dadosProjeto.clienteNome}</h2>

                      {!dadosProjeto.clienteInterno && (
                        <>
                          <p>Tel: {formataTelefone(dadosProjeto.clienteTelefone)}</p>
                          <p>Endereço: {[dadosProjeto.endereco, dadosProjeto.complemento]
                            .filter(Boolean)
                            .join(', ')}</p>
                        </>
                      )}

                    </IonText>
                  </IonCol>
                </IonRow>
                <hr style={{ borderTop: '1px solid', borderStyle: 'dashed', borderColor: 'grey', margin: '5px' }}></hr>

                <IonRow>
                  <IonCol>
                    <IonText>
                      <h2 style={{ margin: '5px 0 5px 0' }}>CUPOM NÃO FISCAL</h2>
                    </IonText>
                  </IonCol>
                </IonRow>

                {dadosProjeto.produtos && dadosProjeto.produtos.length > 0 && (
                  <>
                    <IonRow>
                      <IonCol style={{ padding: '0 0 0 5px' }} size='1'>#</IonCol>
                      <IonCol style={{ padding: '0 0 0 5px' }} size='7'>DESCRIÇÃO</IonCol>
                      <IonCol style={{ padding: '0 0 0 5px' }}>QTDE</IonCol>
                      <IonCol style={{ padding: '0 0 0 5px', textAlign: 'right', marginRight: '5px' }}>VALOR</IonCol>
                    </IonRow>
                    {dadosProjeto.produtos.map((item: any, index: any) => (
                      <IonRow>
                        <IonCol style={{ padding: '0 0 0 5px' }} size='1'>{String(index + 1).padStart(2, '0')}</IonCol>
                        <IonCol style={{ padding: '0 0 0 5px' }} size='7'>



                          {item.descricao && (Array.isArray(item.descricao)) ? (
                            <>
                              <>
                                {(item.tipo === "pizzas") ? (
                                  <div>{item.tamanho} {item.quantidadeSabores} SABORES (<IonLabel style={{ textAlign: "right", fontSize: "12px" }}>R$ {item.valor?.toLocaleString('pt-br', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                  })}</IonLabel>)</div>
                                ) : (
                                  <div>{item.categoria} (<IonLabel style={{ textAlign: "right", fontSize: "12px" }}>R$ {item.valor?.toLocaleString('pt-br', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                  })}</IonLabel>)</div>
                                )}
                              </>
                              {item.descricao.map((item: any, index: number) => (
                                <div key={"desc" + index}>
                                  {item.categoria === "Observação" ? (
                                    <div style={{ textDecoration: "underline" }}>
                                      Observação: {item.descricao}
                                    </div>
                                  ) : (
                                    <div>
                                      - {item.descricao}{" "}
                                      <IonLabel style={{ textAlign: "right", fontSize: "12px" }}>
                                        R$ {item.valor?.toLocaleString("pt-br", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                      </IonLabel>
                                    </div>
                                  )}
                                </div>
                              ))}
                            </>

                          ) : (
                            <>
                              {item.descricao} (<IonLabel style={{ textAlign: "right", fontSize: "12px" }}>R$ {item.valor?.toLocaleString('pt-br', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              })}</IonLabel>)
                            </>
                          )}



                        </IonCol>
                        <IonCol style={{ padding: '0 0 0 5px' }}>{item.quantidade.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}</IonCol>
                        <IonCol style={{ padding: '0 0 0 5px', textAlign: 'right', marginRight: '5px' }}>{item.subtotal.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}</IonCol>
                      </IonRow>
                    ))}
                    <hr style={{ borderTop: '1px solid', borderStyle: 'dashed', borderColor: 'grey', margin: '10px 5px 5px 5px' }}></hr>
                  </>
                )}

                {dadosProjeto.servicos && dadosProjeto.servicos.length > 0 && (
                  <>
                    <IonRow>
                      <IonCol style={{ padding: '0 0 0 5px' }} size='1'>#</IonCol>
                      <IonCol style={{ padding: '0 0 0 5px' }} size='7'>DESCRIÇÃO</IonCol>
                      <IonCol style={{ padding: '0 0 0 5px' }}>QTDE</IonCol>
                      <IonCol style={{ padding: '0 0 0 5px', textAlign: 'right', marginRight: '5px' }}>VALOR</IonCol>
                    </IonRow>
                    {dadosProjeto.servicos.map((item: any, index: any) => (
                      <IonRow>
                        <IonCol style={{ padding: '0 0 0 5px' }} size='1'>{String(index + 1).padStart(2, '0')}</IonCol>
                        <IonCol style={{ padding: '0 0 0 5px' }} size='7'>{item.descricao} x {item.valor.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}</IonCol>
                        <IonCol style={{ padding: '0 0 0 5px' }}>{item.quantidade.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}</IonCol>
                        <IonCol style={{ padding: '0 0 0 5px', textAlign: 'right', marginRight: '5px' }}>{item.subtotal.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}</IonCol>
                      </IonRow>
                    ))}
                    <hr style={{ borderTop: '1px solid', borderStyle: 'dashed', borderColor: 'grey', margin: '10px 5px 5px 5px' }}></hr>
                  </>
                )}

                {dadosProjeto.formaPagamento && (
                  <IonRow>
                    <IonCol size="6">
                      <IonText><strong>FORMA PAGAMENTO:</strong></IonText>
                    </IonCol>
                    <IonCol size="6" style={{ textAlign: 'right' }}>
                      <IonText>{dadosProjeto.formaPagamento.toUpperCase()}</IonText>
                    </IonCol>
                  </IonRow>
                )}

                {dadosProjeto.taxaEntrega && !dadosProjeto.clienteInterno && (
                  <IonRow>
                    <IonCol size="6">
                      <IonText><strong>TAXA DE ENTREGA:</strong></IonText>
                    </IonCol>
                    <IonCol size="6" style={{ textAlign: 'right' }}>
                      <IonText>
                        +R$: {dadosProjeto.taxaEntrega.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </IonText>
                    </IonCol>
                  </IonRow>
                )}

                {dadosProjeto.desconto && (
                  <IonRow>
                    <IonCol size="6">
                      <IonText><strong>DESCONTO:</strong></IonText>
                    </IonCol>
                    <IonCol size="6" style={{ textAlign: 'right' }}>
                      <IonText>
                        -R$: {dadosProjeto.desconto.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </IonText>
                    </IonCol>
                  </IonRow>
                )}


                {dadosProjeto.taxaServico && dadosProjeto.ehComanda && (
                  <IonRow>
                    <IonCol size="6">
                      <IonText><strong>TAXA:</strong></IonText>
                    </IonCol>
                    <IonCol size="6" style={{ textAlign: 'right' }}>
                      <IonText>
                        +R$:{dadosProjeto.taxaServico.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%
                      </IonText>
                    </IonCol>
                  </IonRow>
                )}

                <IonRow>

                  <IonCol size='12' style={{ textAlign: 'right' }}>
                    <h2 style={{ margin: 0 }}>TOTAL R$ {dadosProjeto.valorTotal}</h2>
                  </IonCol>
                </IonRow>


              </IonGrid>
            )}



            {/* <IonActionSheet
              backdropDismiss={true}
              translucent={true}
              isOpen={showActionSheet}
              onDidDismiss={() => setShowActionSheet(false)}
              cssClass='my-custom-class'
              buttons={getButtons()}

            /> */}


            <IonToast
              isOpen={showToast}
              position="middle"
              onDidDismiss={() => setShowToast(false)}
              message={textToast}
              duration={3000}
            />

            <IonLoading
              cssClass='my-custom-class'
              isOpen={showLoading}
              onDidDismiss={() => { setShowLoading(false); }}
              spinner='circles'
            />

          </div>
        </div>
      </IonContent>

    </>


  );
};

export default ({ projeto, closeAction, closeActionSimple }: { projeto: any, closeAction: Function, closeActionSimple: Function }) => (
  <ProjetosCupom projeto={projeto} closeAction={closeAction} closeActionSimple={closeActionSimple}>
  </ProjetosCupom>
)